import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import appInfo from '../constants/appInfo';
import './DeleteAccountPage.css';

function DeleteAccountPage() {
  return (
    <div className="privacy-page">
      <Navbar />
      <main className="privacy-page__main">
        <div className="privacy-page__container">

          <div className="privacy-page__breadcrumb">
            <Link to="/" className="privacy-page__back">← Back to Home</Link>
          </div>

          <h1 className="privacy-page__title">Delete Your {appInfo.name} Account</h1>
          <p className="privacy-page__updated">Last updated: August 1, 2026</p>

          <div className="privacy-page__body">

            <section className="privacy-page__section">
              <p>
                {appInfo.name} is a farm and livestock management application. If you no
                longer wish to use {appInfo.name}, you can permanently delete your account
                and all associated data at any time, using either of the methods below.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>1. Delete Account Within the App (Recommended)</h2>
              <p>The fastest way to delete your account is directly from the app:</p>
              <ul>
                <li>Open the <strong>{appInfo.name}</strong> app on your phone.</li>
                <li>Go to <strong>Settings</strong>.</li>
                <li>Tap <strong>Account</strong>.</li>
                <li>Tap <strong>Delete Account</strong>.</li>
                <li>Confirm the deletion when prompted.</li>
              </ul>
              <p>
                Once confirmed, your account and all data are permanently deleted
                immediately.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>2. Request Deletion via Email</h2>
              <p>
                If you're unable to access the app, you can request account deletion by
                emailing us:
              </p>
              <ul>
                <li>
                  Send an email to{' '}
                  <a href={`mailto:${appInfo.supportEmail}`} className="privacy-page__link">
                    {appInfo.supportEmail}
                  </a>
                </li>
                <li>Include your <strong>registered phone number</strong> so we can verify and locate your account.</li>
                <li>Use the subject line: <strong>"Account Deletion Request"</strong></li>
              </ul>
              <p>
                We will process your request and confirm once your account and data have
                been deleted.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>3. What Gets Deleted</h2>
              <p>When your account is deleted, the following data is permanently removed from our systems:</p>
              <ul>
                <li>Your profile information (name, farm name, phone number, profile photo)</li>
                <li>All animal records (identity, breed, age details)</li>
                <li>Vaccination, deworming, and medical treatment history</li>
                <li>Breeding records</li>
                <li>Doctor/veterinarian contact details you saved</li>
                <li>App preferences (such as language settings)</li>
              </ul>
            </section>

            <section className="privacy-page__section">
              <p className="privacy-page__contact">
                <strong>Note:</strong> Account deletion is permanent and cannot be undone.
                Please make sure you no longer need this data before proceeding.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>4. Contact Us</h2>
              <p>For any questions about this process, please contact us at:</p>
              <p className="privacy-page__contact">
                <strong>Email:</strong>{' '}
                <a href={`mailto:${appInfo.supportEmail}`} className="privacy-page__link">
                  {appInfo.supportEmail}
                </a>
                <br />
                <strong>App name:</strong> {appInfo.name}
              </p>
            </section>

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default DeleteAccountPage;